export const jobs = [
    {
        id: 1,
        jobTitle: "SDE II",
        jobPost: "Software Development Engineer II",
        jobDepartment: ["Python , API, MongoDB", "Dockers, Flutter", "Mobile App Development", "WebApp Developement"]
    },
    {
        id: 2,
        jobTitle: "RE - I (PERCEPTION)",
        jobPost: "Robotics Engineer I",
        jobDepartment: ["C++ ROS1/ROS2", "SLAM, OpenCV.", "CUDA, Pytorch.", "TensorFlow, Navigation"]
    },
    {
        id: 3,
        jobTitle: "SCE I",
        jobPost: "Supply Chain Engineer",
        jobDepartment: ["Lean Six Sigma", "Supply chain management", "Inventory", "JIT"]
    },
    {
        id: 4,
        jobTitle: "SDE 2",
        jobPost: "FullStack Engineer",
        jobDepartment: ["Frontend", "Backend", "JavaScript", "java Developer"]
    },
    {
        id: 5,
        jobTitle: "RE - I (PERCEPTION)",
        jobPost: "Robotics Engineer I",
        jobDepartment: ["C++ ROS1/ROS2", "SLAM, OpenCV.", "CUDA, Pytorch.", "TensorFlow, Navigation"]
    },
    {
        id: 6,
        jobTitle: "SCE I",
        jobPost: "Supply Chain Engineer",
        jobDepartment: ["Lean Six Sigma", "Supply chain management", "Inventory", "JIT"]
    },
]

export const products = [
    {
        id: 1,
        productImg: "https://getpeppermint.co/wp-content/uploads/2023/07/new-45.webp",
        productTitle: "Scrubber Dryer"
    },
    {
        id: 2,
        productImg: "https://getpeppermint.co/wp-content/uploads/2023/04/Untitled-design-59.png",
        productTitle: "TUG AMR"
    },
    {
        id: 3,
        productImg: "https://getpeppermint.co/wp-content/uploads/2023/07/SD-45-Gen2-With-Mopper-View-1-1024x700-1.webp",
        productTitle: "Combo Map"
    }
]



export const cards = [
    {
        id: 1,
        img: 'https://getpeppermint.co/wp-content/uploads/2022/01/Accountable-and-Sustainable.png',
        cardTitle: "Accountable and Sustainable",
        cardDetai: "Due to real-time reports and analytics, the team can see real-time error codes for immediate service. There is 100% safe disposal of water. There is also a 50% lesser fresh water and electricity consumption."
    },
    {
        id: 2,
        img: 'https://getpeppermint.co/wp-content/uploads/2022/01/efficient.png',
        cardTitle: "Efficient and Economicale",
        cardDetai: "Deploying this robot saves up to 66% of the manpower. Our robots consume 50% less electricity and 50% less water compared to traditional machines."
    },
    {
        id: 3,
        img: 'https://getpeppermint.co/wp-content/uploads/2022/01/upgrade.png',
        cardTitle: "Upgrade and Customer Support",
        cardDetai: "We are continuously upgrading our robots to ensure our peak performance and we make sure that your robot does not miss out on any of the upgrades. We provide 24 x 7 support with preventive maintenance."
    },
    {
        id: 4,
        img: 'https://getpeppermint.co/wp-content/uploads/2022/01/Accountable-and-Sustainable.png',
        cardTitle: "Accountable and Sustainable",
        cardDetai: "Due to real-time reports and analytics, the team can see real-time error codes for immediate service. There is 100% safe disposal of water. There is also a 50% lesser fresh water and electricity consumption."
    }
]



export const solutions = [
    {
        id: 1,
        imageSrc: "https://getpeppermint.co/wp-content/uploads/2022/02/House-keeping-new.jpg",
        title: "HouseKeeping",
        buttonText: "Know More"
    },
    {
        id: 2,
        imageSrc: "https://getpeppermint.co/wp-content/uploads/2022/01/Peppermint-robotics-solution-logistics.jpg",
        title: "Logistics & Warehousing",
        buttonText: "Know More"
    },
]


export const iSolutions = [
    {
        id: 1,
        iTitle: "Facility Management",
        iLogo: "fa-industry",
        iAbout: "The industry with the mandate to bring automation during the pandemic is Facility Management. With Peppermint, we saw partners bring automation to multiple industries, at various stages of the pandemic to ensure uninterrupted autonomous operations."

    },
    {
        id: 2,
        iTitle: "Commercial Real Estate & Hospitality",
        iLogo: "fa-hospital",
        iAbout: "With class-leading features, Peppermint brings predictable cleaning operations at Commercial Real Estate & Hospitality locations where clients are taking steps to ensure the safety of their employees or patrons.With smart sensors and adaptive tech, Peppermint"

    },
    {
        id: 3,
        iTitle: "Manufacturing",
        iLogo: "fa-industry",
        iAbout: "Large Manufacturing facilities are not averse to automation. A housekeeping robot like Peppermint is a welcome addition in ensuring that the highest cleaning standards are upheld and the floor is always clean. A clean floor is a tick for employee wellness, compliance, and safety."

    },
    {
        id: 4,
        iTitle: "Warehouses & Logistics",
        iLogo: "fa-car",
        iAbout: "As all energies in Warehouses are towards ensuring throughput, a clean floor provides a gateway for faster processing of material to the next custodian in the supply chain. With smart sensors and adaptive tech, Peppermint."

    },
    {
        id: 5,
        iTitle: "Transport Hubs",
        iLogo: "fa-car",
        iAbout: "As travel resumes for large parts of the world, hygiene & cleanliness remains the top priority for both hosts and the traveler. Transport Hubs have an abundance of a movement demanding higher cleaning frequencies paving the way"

    },
    {
        id: 6,
        iTitle: "Healthcare & Pharmaceutical",
        iLogo: "fa-dollar-sign",
        iAbout: "Hospitals and Pharmaceuticals Manufacturing have been at the forefront of the pandemic. With extremely high cleaning standards being the mandate, Peppermint Robots provided these facilities cleaning accountability to operations across."

    }

]